import { __spreadArrays } from "tslib";
import * as _ from 'lodash';
import { TpaTypes, TpaWidgetTypes } from '@wix/adi-core-types';
import { isTpaWidgetType } from './external';
/**
 * @returns recommended TPAs from content server that are specific for selected
 * category and include also widgets from Home page sections for this category
 */
export function getAppsRecommendation(content) {
    var homePageSections = _.get(content, ['pages', '0', 'sections']);
    var homePageTpas = getHomePageTpas(homePageSections);
    var structureAppsRecommendation = content
        ? buildStructureAppsRecommendation(content.recommendedApps)
        : [];
    var uniqueStructureAppsRecommendation = structureAppsRecommendation.filter(function (recommendation) {
        return !homePageTpas.find(function (homePageTpa) { return homePageTpa.type === recommendation.type; });
    });
    return __spreadArrays(homePageTpas, uniqueStructureAppsRecommendation);
}
function getHomePageTpas(homePageSections) {
    if (!homePageSections) {
        return [];
    }
    var homePageTpas = homePageSections
        .filter(function (section) { return isTpaWidgetType(section.ceType); })
        .map(function (section) {
        return {
            type: TpaWidgetTypes[section.ceType],
            preferred: true,
        };
    });
    if (shouldAddSyncedBookings(homePageSections)) {
        homePageTpas.push({
            type: TpaTypes.Bookings,
            preferred: true,
        });
    }
    return homePageTpas;
}
function shouldAddSyncedBookings(homePageSections) {
    if (homePageSections &&
        homePageSections.find(function (section) {
            return Boolean(section &&
                section.syncWithBooking &&
                section.syncWithBooking !== 'none');
        })) {
        return true;
    }
    return false;
}
function buildStructureAppsRecommendation(recommendedApps) {
    return !recommendedApps
        ? []
        : recommendedApps.map(function (type) {
            return {
                type: type,
                preferred: false,
            };
        });
}
//# sourceMappingURL=appsRecommendation.js.map